// extracted by mini-css-extract-plugin
module.exports = {"hidden":"contents_hidden__Bnkml","textEmphasis":"contents_textEmphasis__4G2KY","infoArea":"contents_infoArea__mZ8Ot","infoJobflex":"contents_infoJobflex__R5uxo"};